import { createContext, useContext } from "react";
import type { RowData } from "@tanstack/react-table";
import type { DataGridRow } from "../../columns/types";

type DisabledReasonLookup = (rowId: string) => string | undefined;

const NO_REASON: DisabledReasonLookup = () => undefined;

/**
 * Why a row can't be selected, looked up by row id. The body provides it from
 * `rowSelection.getDisabledReason`; keyed by id so cells stay row-type free.
 */
export const DisabledReasonContext =
    createContext<DisabledReasonLookup>(NO_REASON);

/** The disabled reason for `row`; only read when the row can't be selected. */
export const useDisabledReason = <TData extends RowData>(
    row: DataGridRow<TData>,
) => {
    const lookup = useContext(DisabledReasonContext);
    return row.getCanSelect() ? undefined : lookup(row.id);
};
